enum Bingo40TicketBook {
  Pink = 'pink',
  Black = 'black',
  Amber = 'amber',
  Teal = 'teal'
}


function getTicketBookSequence(): Bingo40TicketBook[] {
  return [
    Bingo40TicketBook.Pink,
    Bingo40TicketBook.Black,
    Bingo40TicketBook.Amber,
    Bingo40TicketBook.Teal
  ];
}


function getTicketBookNameForTicketBookId(ticketBookId: Bingo40TicketBook): string {
  switch (ticketBookId) {
    case Bingo40TicketBook.Pink:
      return 'Pink';
    case Bingo40TicketBook.Black:
      return 'Black';
    case Bingo40TicketBook.Amber:
      return 'Amber';
    case Bingo40TicketBook.Teal:
      return 'Teal';
  }
}

export { Bingo40TicketBook, getTicketBookSequence, getTicketBookNameForTicketBookId };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/bingo-40/_domain/models/ticket-book.ts